<template>
  <BaseModal
    v-model="isVisible"
    :preset="BaseModalPresetEnum.notifying"
    clickToClose
    @update:modelValue="onClose"
  >
    <template #default>
      <div
        :class="[
          $style.text,
          notification.type === NotificationTypeEnum.ERROR ? $style.error : $style.success
        ]"
      >
        {{ notification.text }}
      </div>

      <div
        v-if="notification.counter > 1"
        :class="$style.badge"
      >
        {{ notification.counter > 99 ? '99+' : notification.counter }}
      </div>
    </template>
  </BaseModal>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { BaseModalPresetEnum } from '@models/base/baseModal'
import { NotificationItemType, NotificationTypeEnum } from '@notifications/definitions/models'
import { useNotificationsStore } from '@notifications/stores/notificationsStore'
import { prepareCssValue } from '@scripts/helpers/cssHelpers'

import BaseModal from '@components/base/BaseModal.vue'

const { notification } = defineProps<{
  notification: NotificationItemType
}>()

const notificationsStore = useNotificationsStore()
const isVisible = ref(true)

const contentColor = computed(() => notification.type === NotificationTypeEnum.ERROR ? 'var(--color-red)' : 'var(--color-green)')

const onClose = () => {
  isVisible.value = false
  notificationsStore.removeNotification(notification.key)
}

// Следим за изменением counter
watch(
  () => notification.counter,
  (newVal) => {
    if (newVal > 0) {
      isVisible.value = true
    }
  }
)
</script>

<style lang="scss" module>
.text {
  text-align: center;
  color: v-bind('prepareCssValue(contentColor)');
  @include line-height(18);
}

.badge {
  position: absolute;
  top: 10px;
  right: 12px;
  border-radius: 50%;
  background-color: v-bind('prepareCssValue(contentColor)');
  color: var(--color-primary-light);
  white-space: nowrap;
  @include font-type-light(11, 11);
  @include flex-center-row();
  @include size(24);
}
</style>
